import { pick } from 'lodash-es';
import type { BlotterTableTradeFilter } from './useTradeFilter';

// The Trade websocket denotes off platform/unattributed trades with an empty string.
export const OFF_PLATFORM_TRADE_USER = '';

const SERVER_FILTER_KEYS: (keyof BlotterTableTradeFilter)[] = [
  'StartDate',
  'EndDate',
  'Statuses',
  'SubAccounts',
  'Symbols',
  'HideApiCalls',
  'OrderID',
  'RFQID',
  'Markets',
];

export type TradesServerFilter = Partial<BlotterTableTradeFilter> & {
  ExcludeUsers?: string[];
};

export function toTradesServerFilter(
  filter: BlotterTableTradeFilter | undefined,
  options?: { enableTradesUserBackendFiltering?: boolean }
): TradesServerFilter | undefined {
  if (!filter) {
    return filter;
  }

  const serverFilter: TradesServerFilter = pick(filter, SERVER_FILTER_KEYS);
  if (options?.enableTradesUserBackendFiltering && filter.HideOffPlatform) {
    serverFilter.ExcludeUsers = [OFF_PLATFORM_TRADE_USER];
  }
  return serverFilter;
}
